import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomePageComponent } from './home/home-page/home-page.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  {
    path: 'home',
    loadChildren: () =>
      import('src/app/pages/home/home.module').then((m) => m.HomeModule)
  },
    {
    path: 'CS',
      loadChildren: () =>
        import('src/app/pages/station-managment/charge-station.module').then((m) => m.ChargeStationModule)
  },
  {
    path: 'CP',
    loadChildren: () =>
      import('src/app/pages/charge-units-management/charge-points.module').then((m) => m.ChargePointsModule)
  },
  {
    path: 'CPO',
    loadChildren: () =>
      import('src/app/pages/cpo-registration/cpo-registration.module').then((m) => m.CPORegistrationModule)
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('src/app/pages/account-profile/account-profile.module').then((m) => m.AccountProfileModule)
  },
  {
    path: 'UserManagement',
    loadChildren: () =>
      import('src/app/pages/user-management/user-management.module').then((m) => m.UserManagementModule)
  },
  {
    path: 'Alerts',
    loadChildren: () =>
      import('src/app/pages/alerts-management/alerts.module').then((m) => m.AlertsModule)
  },
  {
    path: 'ChargingHistory',
    loadChildren: () =>
      import('src/app/pages/charge-history/charge-history.module').then((m) => m.ChargeHistoryModule)
  },
  {
    path: 'ChargingSummary',
    loadChildren: () =>
      import('src/app/pages/charge-summary/charge-summary.module').then((m) => m.ChargeSummaryModule)
  },
  //
  //{
  //  path: 'Customer',
  //  loadChildren: () =>
  //    import('src/app/pages/customers/customers.module').then((m) => m.CustomersModule)
  //},
  //{
  //  path: 'Setting',
  //  loadChildren: () =>
  //    import('src/app/pages/settings/settings.module').then((m) => m.SettingsModule)
  //},
  {
    path: 'SupportTickets',
    loadChildren: () =>
      import('src/app/pages/support-ticket/support-ticket.module').then((m) => m.SupportTicketModule)
  },
  //{
  //  path: 'Transaction',
  //  loadChildren: () =>
  //    import('src/app/pages/transactions/transactions.module').then((m) => m.TransactionsModule)
  //},

  //{
  //  path: 'Token',
  //  loadChildren: () =>
  //    import('src/app/pages/tokens/tokens.module').then((m) => m.TokensModule)
  //},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule { }
